import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/t-tech-green.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2ffc092c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/",
  style: {"width":"139px","min-width":"139px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Tech Titans",
    class: "img-fluid"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler ms-auto",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "ms-auto navbar-nav mb-2 mb-lg-0 text-start" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownLearning",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_9 = { class: "dropdown-menu-inner" }
const _hoisted_10 = { class: "dropdown-inner-area" }
const _hoisted_11 = { class: "dropdown-title" }
const _hoisted_12 = { class: "dropdown-link-area mobfx" }
const _hoisted_13 = { class: "dropdown-main" }
const _hoisted_14 = { class: "dropdown-main-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dpad" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-soundwave" }, null, -1))
const _hoisted_18 = { class: "dropdown-main-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cpu" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-palette" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box2-heart" }, null, -1))
const _hoisted_22 = { class: "dropdown-main-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bar-chart" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-laptop" }, null, -1))
const _hoisted_25 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownLearning",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_26 = { class: "dropdown-menu-inner" }
const _hoisted_27 = { class: "dropdown-inner-area" }
const _hoisted_28 = { class: "dropdown-title" }
const _hoisted_29 = { class: "dropdown-link-area" }
const _hoisted_30 = { class: "dropdown-main" }
const _hoisted_31 = { class: "dropdown-main-group" }
const _hoisted_32 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownLearning",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_33 = { class: "dropdown-menu-inner" }
const _hoisted_34 = { class: "dropdown-inner-area" }
const _hoisted_35 = { class: "dropdown-title" }
const _hoisted_36 = { class: "dropdown-link-area" }
const _hoisted_37 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownLearning",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_38 = {
  key: 0,
  class: "d-lg-none"
}
const _hoisted_39 = { class: "nav-item dropdown" }
const _hoisted_40 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownAccount",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_46 = {
  key: 1,
  class: "d-lg-none mb-2 me-4",
  style: {"padding-left":"16px"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/login" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "tt-dropdown-item btn p-0 m-0 btn-sm bg-transparent btn-light border-0 text-nowrap"
  }, "Log In")
], -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 2,
  class: "d-lg-none mb-2 me-4",
  style: {"margin-left":"16px"}
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/members/signup" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "tt-dropdown-item btn p-0 m-0 bg-transparent btn-sm btn-light border-0 text-nowrap"
  }, "Sign Up")
], -1))
const _hoisted_51 = [
  _hoisted_50
]

import { onBeforeMount } from 'vue';
import axios from 'axios';
// import TopLabel from "@/components/elements/TopLabel.vue";
import TopNavBarGame from '@/components/TopNavbarGame.vue';
import LanguageSelector from '@/components/elements/LanguageSelector.vue';
import { getCookie, cleanUser, generateRandomAlphaNum } from "@/common/common.js";
import { userMenuStore } from '@/store/userMenuStore';
import { userMainStore } from '@/store/userMainStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavBar',
  setup(__props) {

const main = userMainStore();
const umenu = userMenuStore();
let token = localStorage.getItem("token");
let school = localStorage.getItem("school");
let iscompany = localStorage.getItem("iscompany");
// let isstudent = localStorage.getItem("isstudent");
let isteacher = localStorage.getItem("isteacher");

let loggedin = false;

onBeforeMount(
	async () => {
		if (getCookie("uid")) {
			loggedin = true;
		}
	});


const logOut = async () => {
	await axios
		.get('/api/v1/logout', {
			headers: { Authorization: `${token}` },
			withCredentials: true
		})
		.then(() => {
			cleanUser();
			document.location = "/login?" + generateRandomAlphaNum(5);
		});
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-lg navbar-light justify-content-start w-100 p-0 m-0", { 'main-nav' : _unref(main).isavailable }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "search")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(TopNavBarGame)
          ]),
          _createElementVNode("li", {
            class: _normalizeClass(["nav-item", { 'fw-semibold' : _unref(main).isavailable }])
          }, [
            _createVNode(_component_router_link, {
              onClick: _ctx.$scrollToTop,
              to: "/",
              "aria-current": "page",
              class: "nav-link active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('menu.home', 'Home')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["nav-item dropdown animatedmenu", { 'fw-semibold' : _unref(main).isavailable }])
          }, [
            _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('menu.learning', 'Learning')), 1),
            _createElementVNode("ul", {
              class: _normalizeClass(["dropdown-menu mainm learning dropdown-menu-end", {  'homepage-user-menu' : _unref(main).isavailable }]),
              "aria-labelledby": "navbarDropdownLearning"
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('menu.subscriptions13up', 'All courses, one subscription — from age 13 and up')), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/l/learning",
                      "aria-current": "page",
                      class: "dropdown-link tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.explorecourses', 'Explore Courses')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/members/subscriptions",
                      "aria-current": "page",
                      class: "dropdown-link tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.subscriptions', 'Subscriptions')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/t/colleges",
                      "aria-current": "page",
                      class: "dropdown-link tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.schools', 'College Subscriptions')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/learners",
                      "aria-current": "page",
                      class: "dropdown-link tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.learners', 'Learners')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/s/gamedesign",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createTextVNode(" Game Design")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/s/animation",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _createTextVNode(" Animation")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/s/sounddesign",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createTextVNode(" Sound Design")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/s/webdevelopment",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createTextVNode(" Web Development")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/s/graphics",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20,
                          _createTextVNode(" Graphic/UI/UX Design")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/s/digitalart",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _createTextVNode(" Digital Art")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/s/marketing",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _createTextVNode(" Digital Marketing")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/s/computerliteracy",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _createTextVNode(" Computer Literacy")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ])
              ])
            ], 2)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["nav-item dropdown animatedmenu", { 'fw-semibold' : _unref(main).isavailable }])
          }, [
            _createElementVNode("a", _hoisted_25, _toDisplayString(_ctx.$t('menu.recruitment', 'Recruitment')), 1),
            _createElementVNode("ul", {
              class: _normalizeClass(["dropdown-menu mainm recruitment", {  'homepage-user-menu' : _unref(main).isavailable }]),
              "aria-labelledby": "navbarDropdownLearning"
            }, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('menu.forcompanies', 'For Companies')), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/l/recruiting",
                      "aria-current": "page",
                      class: "dropdown-link tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.recruitmentups', 'Recruitement & Upskilling')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/r/job",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('menu.postajob', 'Post a Job')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        onClick: _ctx.$scrollToTop,
                        to: "/r/joblistings",
                        "aria-current": "page",
                        class: "dropdown-item tt-dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('menu.findajob', 'Find a Job')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ])
              ])
            ], 2)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["nav-item dropdown animatedmenu", { 'fw-semibold' : _unref(main).isavailable }])
          }, [
            _createElementVNode("a", _hoisted_32, _toDisplayString(_ctx.$t('menu.collegeadtech', 'College AdTech')), 1),
            _createElementVNode("ul", {
              class: _normalizeClass(["dropdown-menu mainm collegeadtech", {  'homepage-user-menu' : _unref(main).isavailable }]),
              "aria-labelledby": "navbarDropdownLearning"
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('menu.forcolleges', 'For Colleges')), 1),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/t/colleges",
                      "aria-current": "page",
                      class: "dropdown-link tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.schools', 'College Learning')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ])
            ], 2)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["nav-item dropdown animatedmenu", { 'fw-semibold' : _unref(main).isavailable }])
          }, [
            _createElementVNode("a", _hoisted_37, _toDisplayString(_ctx.$t('menu.about', 'About')), 1),
            _createElementVNode("ul", {
              class: _normalizeClass(["dropdown-menu mainm", {  'homepage-user-menu' : _unref(main).isavailable }]),
              "aria-labelledby": "navbarSupportedContent"
            }, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _ctx.$scrollToTop,
                  to: "/t/about",
                  "aria-current": "page",
                  "data-toggle": "collapse",
                  class: "dropdown-item tt-dropdown-item"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('menu.aboutus', 'About Us')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _ctx.$scrollToTop,
                  to: "/t/contact",
                  "aria-current": "page",
                  class: "dropdown-item tt-dropdown-item"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('menu.contact', 'Contact')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _ctx.$scrollToTop,
                  to: "/t/colleges",
                  "aria-current": "page",
                  class: "dropdown-item tt-dropdown-item"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('menu.schools', 'College Subscriptions')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _ctx.$scrollToTop,
                  to: "/members/subscriptions",
                  "aria-current": "page",
                  class: "dropdown-item tt-dropdown-item"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('menu.subscriptions', 'Subscriptions')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ], 2)
          ], 2),
          (_unref(loggedin))
            ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                _createElementVNode("li", _hoisted_39, [
                  _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t('menu.myaccount', 'My Account')), 1),
                  _createElementVNode("ul", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(umenu).refresh=!_unref(umenu).refresh)),
                    class: _normalizeClass([{  'homepage-user-menu' : _unref(main).isavailable }, "dropdown-menu"]),
                    "aria-labelledby": "navbarDropdownAccount"
                  }, [
                    (_unref(iscompany))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                          _createVNode(_component_router_link, {
                            onClick: _ctx.$scrollToTop,
                            to: "/u/my/company",
                            "aria-current": "page",
                            class: "dropdown-item tt-dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('menu.mycompany', 'My Company')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(isteacher))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                          _createVNode(_component_router_link, {
                            onClick: _ctx.$scrollToTop,
                            to: "/u/tr/dashboard",
                            "aria-current": "page",
                            class: "dropdown-item tt-dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('menu.teacherdashboard', 'Teacher Dashboard')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(iscompany))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                          _createVNode(_component_router_link, {
                            onClick: _ctx.$scrollToTop,
                            to: "/u/my/dashboard",
                            "aria-current": "page",
                            class: "dropdown-item tt-dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('menu.mydashboard', 'My Dashboard')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(school))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                          _createVNode(_component_router_link, {
                            onClick: _ctx.$scrollToTop,
                            to: "/u/my/account",
                            "aria-current": "page",
                            class: "dropdown-item tt-dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('menu.myaccount', 'My Account')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_45,
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        role: "button",
                        onClick: logOut,
                        class: "dropdown-item tt-dropdown-item"
                      }, _toDisplayString(_ctx.$t('menu.signout', 'Log Out')), 1)
                    ])
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_unref(loggedin))
            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _hoisted_48))
            : _createCommentVNode("", true),
          (!_unref(loggedin))
            ? (_openBlock(), _createElementBlock("span", _hoisted_49, _hoisted_51))
            : _createCommentVNode("", true),
          _createVNode(LanguageSelector, {
            class: "me-4 d-lg-none",
            style: {"margin-left":"10px"}
          })
        ])
      ])
    ])
  ], 2))
}
}

})